import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  IconButton,
  Button,
  Modal,
  InputBox,
  TextField,
  MenuItem,
  Typography,
  Divider,
  Icon,
} from '@platform/ui';
import { getLinkLocations } from '../../../modules/dicom-measurement/src/constants';

const interpretedTypes = [
  { key: 'GTV', label: 'GTV' },
  { key: 'CTV', label: 'CTV' },
  { key: 'PTV', label: 'PTV' },
  { key: 'ORGAN', label: 'Organ' },
];

export function UpdateROIForm({ roi, links = [], onFinished , guideline = 'default'}) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [name, setName] = useState('');
  const [interpretedType, setInterpretedType] = useState('');
  const [observationLabel, setObservationLabel] = useState('');
  const [open, setOpen] = useState(false);
  const [linkID, setLinkID] = useState('default');

  const handleOpen = () => {
    setOpen(true);
    setName(roi.ROIName);
    setInterpretedType(roi.RTROIObservations.RTROIInterpretedType);
    setObservationLabel(roi.RTROIObservations.ROIObservationLabel);
    setLinkID(roi.link_id);
  };

  const handleUpdateClick = async () => {
    try {
      setIsProcessing(true);
      const rois = [
        {
          ROIName: name,
          RTROIObservations: {
            RTROIInterpretedType: interpretedType,
            ROIObservationLabel: observationLabel,
          },
          link_id: linkID === 'default' ? '' : linkID,
          too_small_to_measure: roi.measurable || null,
          unequivocal: roi.equivocal || null,
        },
      ].map((roi) => {
        Object.keys(roi).forEach((key) => {
          if (roi[key] == null) delete roi[key];
        });
        return roi;
      });
      await onFinished(rois[0]);
      setOpen(false);
    } catch (err) {
      console.log(err);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <>
      <IconButton onClick={handleOpen} color='primary' size='small'>
        <Icon name={'edit-light'} width='24px' height='24px' />
      </IconButton>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div>
          <Typography component='h2' variant='h6' color='primary' gutterBottom>
            {'New ROI'}
          </Typography>
          <Divider />
          <InputBox label={'Name:'}>
            <TextField
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
            />
          </InputBox>
          <InputBox label={'Interpreted Type:'}>
            <TextField
              select
              value={interpretedType}
              onChange={(e) => setInterpretedType(e.target.value)}
              fullWidth
            >
              {interpretedTypes.map(({ key, label }) => (
                <MenuItem key={key} value={key}>
                  {label}
                </MenuItem>
              ))}
            </TextField>
          </InputBox>
          <InputBox label={'Observation Label:'}>
            <TextField
              select
              value={observationLabel}
              onChange={(evt) => setObservationLabel(evt.target.value)}
              fullWidth
            >
              <MenuItem key={'default'} value={'default'}>
                {'------'}
              </MenuItem>
              {getLinkLocations(guideline).map((i) => (
                <MenuItem key={i.value} value={i.value}>
                  {i.label}
                </MenuItem>
              ))}
            </TextField>
          </InputBox>
          <InputBox label={'Link:'}>
            <TextField
              select
              value={linkID}
              onChange={(e) => setLinkID(e.target.value)}
              fullWidth
            >
              <MenuItem key={'default'} value={'default'}>
                {'------'}
              </MenuItem>
              {links.map((i) => (
                <MenuItem key={i.link_id} value={i.link_id}>
                  {i.name}
                </MenuItem>
              ))}
            </TextField>
          </InputBox>
        </div>
        <div style={{ marginTop: 'auto' }}>
          <Button
            data-cy='submit-new-roi-button'
            onClick={handleUpdateClick}
            color='primary'
            variant='outlined'
            medium
            disabled={isProcessing}
            fullWidth
          >
            Update
          </Button>
        </div>
      </Modal>
    </>
  );
}
UpdateROIForm.propTypes = {
  roi: PropTypes.object,
  links: PropTypes.array,
  onFinished: PropTypes.func,
};
